const CANCELLED_BY_TYPES = ["CLIENT", "DRIVER", "ENTERPRISE", "SYSTEM"];

function isPositiveInteger(value) {
  return Number.isInteger(Number(value)) && Number(value) > 0;
}

function hasOptionalValue(value) {
  return value !== null && value !== undefined && value !== "";
}

export function validateBookingCancellationPayload(payload) {
  if (!isPositiveInteger(payload?.booking_id)) {
    return "El booking es obligatorio.";
  }

  if (!CANCELLED_BY_TYPES.includes(payload?.cancelled_by_type)) {
    return "El tipo de usuario que cancela no es valido.";
  }

  if (
    hasOptionalValue(payload?.cancelled_by_id) &&
    !isPositiveInteger(payload.cancelled_by_id)
  ) {
    return "El usuario que cancela no es valido.";
  }

  if (!isPositiveInteger(payload?.cancellation_reason_id)) {
    return "El motivo de cancelacion es obligatorio.";
  }

  if (
    hasOptionalValue(payload?.booking_status_before) &&
    String(payload.booking_status_before).trim().length > 50
  ) {
    return "El estado previo no debe exceder 50 caracteres.";
  }

  if (
    !Number.isFinite(Number(payload?.cancellation_fee)) ||
    Number(payload.cancellation_fee) < 0
  ) {
    return "La penalidad de cancelacion no es valida.";
  }

  return null;
}
